"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKey = void 0;
function mapKey(subject, predicate, thisArg) {
    return Object.keys(subject).map(function (k, i, a) {
        return predicate.apply(this, [k, i, a, subject]);
    }, thisArg);
}
exports.mapKey = mapKey;
//# sourceMappingURL=mapKey.js.map